(function() {

    'use strict';

    angular.module('app').
    controller('CarriersFuelLeviesController', CarriersFuelLeviesController);

    CarriersFuelLeviesController.$inject = [
        'toastr', 
        'Carrier', 
        'FuelLeviesTableService', 
        '$routeParams'
    ];

    function CarriersFuelLeviesController(
        toastr, 
        Carrier, 
        FuelLeviesTableService, 
        $routeParams
    ) {

        var vm = this;
        let serviceDetailsList = {};
        init();

        function init() {
            var paginationData = {
                size: 5,
                page: 0,
                sort: 'clientId'
            };
            getFuelLevies(paginationData);
        };

        function getFuelLevies(requestPagination, filters) {
            var requestData = {};
            angular.extend(requestData, requestPagination, filters);
            Carrier.getCarriers(function (data) {
                serviceDetailsList.carriers = data;
            }, function (error) {
                console.log(error);
            }).getServices(function (data) {
                serviceDetailsList.services = data;
                vm.fuelLeviesTable = new FuelLeviesTableService(serviceDetailsList).tableData;
            });
        }
    }
})();


// WEBPACK FOOTER //
// ./js/controllers/carriers/CarriersFuelLeviesController.js